export default __webpack_public_path__ + "static/media/refresh.e6480a35.svg";